export default {
  props: {
    width: {
      type: Number,
      default: 72
    },
    height: {
      type: Number,
      default: 72
    }
  },
  data() {
    return {
      imgurl: require('@/assets/mapv2/defaultImage.jpg')
    };
  },
  methods: {}
};